import { render, staticRenderFns } from "./formsubs.vue?vue&type=template&id=7458bb47&scoped=true"
import script from "./formsubs.vue?vue&type=script&lang=js"
export * from "./formsubs.vue?vue&type=script&lang=js"
import style0 from "./formsubs.vue?vue&type=style&index=0&id=7458bb47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458bb47",
  null
  
)

export default component.exports